module.exports = __webpack_public_path__ + "static/media/productos_botanas_cacahuate_enchilado.64dab790.jpg";